var map = {
	"./account.svg": [
		2064,
		64
	],
	"./apps.svg": [
		9763,
		763
	],
	"./arrow-back.svg": [
		9566,
		185
	],
	"./arrow-down.svg": [
		1759,
		759
	],
	"./arrow-left.svg": [
		5648,
		648
	],
	"./burger.svg": [
		1444,
		444
	],
	"./chat-icon.svg": [
		2401
	],
	"./chats-bubble.svg": [
		3459,
		459
	],
	"./chats.svg": [
		1012,
		12
	],
	"./close.svg": [
		5837,
		837
	],
	"./dashboard.svg": [
		7461,
		461
	],
	"./groups-list.svg": [
		3116,
		116
	],
	"./heart.svg": [
		9733,
		733
	],
	"./home.svg": [
		4174,
		174
	],
	"./links.svg": [
		1278,
		278
	],
	"./logo-100x22-violet.svg": [
		9792
	],
	"./logout.svg": [
		4277,
		277
	],
	"./notification.svg": [
		566,
		566
	],
	"./notification_unread.svg": [
		2468,
		468
	],
	"./search.svg": [
		4343,
		343
	],
	"./send-message.svg": [
		8683,
		683
	],
	"./settings.svg": [
		716,
		716
	],
	"./user-groups.svg": [
		5987,
		987
	],
	"./variation-spark.svg": [
		6062,
		62
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4913;
module.exports = webpackAsyncContext;